import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";
// hooks
import { useParams } from "react-router-dom";

// components
import Spacer from "../../../../../../../components/Spacer";
import Typography from "../../../../../../../components/Text";

//hooks
import { useGoalHistory, useRbacObjectPermissions } from "../../../../../../../api/hooks";
import usePageWidthBreakpoint from "../../../../../../../hooks/usePageWidthBreakpoint";
import useSearchQueryParams from "../../../../../../../hooks/useSearchQueryParams";

import { parseGoalPermissionsForUser } from "../../../../utils";
// utils
import { isEntryMessageOnly } from "../../utils";

//config
import Config from "../../../../config";
// styles
import css from "../../ActivityStreamPanel.module.scss";
import HistoryListEntry from "../HistoryListEntry";
import HistoryMessageEntry from "../HistoryMessageListEntry";

const GoalProgress = () => {
	const { isDesktop } = usePageWidthBreakpoint();
	const { goal_id: goalId } = useParams<{ goal_id: string }>();

	const { handleQueryChange } = useSearchQueryParams({
		schema: Config.queryParametersSchema,
	});

	const { data: permissions } = useRbacObjectPermissions("goal", goalId || "");
	const { data: goalProgressHistory = [] } = useGoalHistory({
		goalID: goalId || "",
		type: "progress",
		sortDirection: "desc",
		sortName: "as_of",
	});

	const { userCanEditHistoryAsOfDate } = parseGoalPermissionsForUser(permissions);

	const [animationParent] = useAutoAnimate();

	return (
		<div>
			<div className={`${css.panelContent} ${isDesktop ? "" : css.mobile}`}>
				<div className={css.header}>
					<Typography weight="regular" size="sub-heading">
						Goal Progress
					</Typography>
				</div>
				<Spacer height={2} />
				<div className={css.content}>
					<div className={css.historyList} ref={animationParent}>
						{goalProgressHistory.map((entry) => {
							return (
								<div key={`history-list-entry-${entry?._id}`} className={css.entryWrapper}>
									{isEntryMessageOnly(entry) ? (
										<HistoryMessageEntry showAsOf entry={entry} />
									) : (
										<HistoryListEntry
											showAsOf
											entry={entry}
											onSelect={
												userCanEditHistoryAsOfDate
													? () =>
															handleQueryChange({
																modal: "edit-as-of-date",
																editHistoryEntryId: entry._id,
															})
													: undefined
											}
										/>
									)}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default GoalProgress;
